import useCrud from '../useCrud'

const useMunicipality = () => {
  const { get: getMunicipalityTypes } = useCrud('/admin/v1/institutions/municipality_type')

  return { getMunicipalityTypes }
}

export default useMunicipality
